import dayjs, { type Dayjs } from "dayjs";

export interface GenericTimeValue {
  hour: number;
  minute: number;
}

export const GENERIC_TIME_FORMAT = "HH:mm";

export const formatGenericTimeInput = (text: string): string => {
  const digits = text.replace(/\D/g, "");
  if (!digits) {
    return "";
  }

  const firstHourDigit = Number(digits[0]);
  if (digits.length === 1 && firstHourDigit <= 2) {
    return digits;
  }

  let hour: string;
  let nextDigitIndex: number;
  if (firstHourDigit > 2) {
    hour = `0${digits[0]}`;
    nextDigitIndex = 1;
  } else if (digits[0] === "2" && Number(digits[1]) > 3) {
    hour = `0${digits[0]}`;
    nextDigitIndex = 1;
  } else {
    hour = digits.slice(0, 2);
    nextDigitIndex = 2;
  }

  if (digits.length <= nextDigitIndex) {
    return hour;
  }

  const firstMinuteDigit = Number(digits[nextDigitIndex]);
  if (firstMinuteDigit > 5) {
    return `${hour}:0${digits[nextDigitIndex]}`;
  }

  const minute = digits.slice(nextDigitIndex, nextDigitIndex + 2);
  return `${hour}:${minute}`;
};

export const formatGenericTime = (value: Dayjs | null): string =>
  dayjs.isDayjs(value) && value.isValid()
    ? value.format(GENERIC_TIME_FORMAT)
    : "";

export const parseGenericTime = (text: string): GenericTimeValue | null => {
  const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(text.trim());
  if (!match) {
    return null;
  }

  return {
    hour: Number(match[1]),
    minute: Number(match[2]),
  };
};

export const combineGenericTime = (
  time: GenericTimeValue,
  preserveHiddenTimeFrom?: Dayjs | null,
): Dayjs => {
  const base =
    dayjs.isDayjs(preserveHiddenTimeFrom) && preserveHiddenTimeFrom.isValid()
      ? preserveHiddenTimeFrom
      : dayjs().second(0).millisecond(0);

  return base.hour(time.hour).minute(time.minute);
};
